import { ComponentProps, FC } from 'react'

import { AddToBagButton as AddToBag } from '../../../../../components/atoms/AddToBagButton'
import { CtaButton } from '../../../../../components/atoms/CtaButton'
import { trackEvent } from '../../../../../lib/analytics'

type AddToBagButtonProps = {
  cta?: string
  className?: string
  isDisabled?: boolean
  isProcessing?: boolean
  isWaitlist?: boolean
  onClickAddToBag: () => Promise<void>
} & Partial<ComponentProps<typeof AddToBag>>

export const AddToBagButton: FC<AddToBagButtonProps> = ({
  cta,
  className,
  isDisabled,
  isProcessing,
  isWaitlist,
  onClickAddToBag,
  ...rest
}) => {
  const variant = isWaitlist ? 'ghost' : 'filled'

  return (
    <AddToBag
      {...trackEvent({
        category: 'product details',
        action: 'add to cart',
        label: cta,
      })}
      ButtonComponent={CtaButton}
      allCaps
      aria-disabled={isDisabled}
      block
      className={className}
      data-testid='add-to-bag-button'
      disabled={isDisabled}
      isProcessing={isProcessing}
      onClick={onClickAddToBag}
      variant={variant}
      {...rest}
    >
      {cta}
    </AddToBag>
  )
}
